import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { portalConst } from '@app/config';
import { AlertService } from '@app/core';
import { AttachmentService } from '@app/core/services/attachment.service';
import { SHARED_MODULES } from '@app/shared';
import { FileViewerComponent } from '@app/shared/modules/file-viewer/file-viewer.component';
import { Vimeo } from '@app/shared/utils';
import { map, Observable, take } from 'rxjs';
import { AttachmentTypeEnum } from './attachment-type.enum';

@Component({
  imports: [SHARED_MODULES, FileViewerComponent],
  templateUrl: './modal-file-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalFileViewerComponent implements OnInit {
  public readonly data = inject(DIALOG_DATA);
  private readonly _attachmentService = inject(AttachmentService);
  private readonly _dialogRef = inject<DialogRef<boolean>>(DialogRef);
  private readonly _alertService = inject(AlertService);

  public title: string;
  public dataViewer: any;
  public video$: Observable<any>;

  public ngOnInit() {
    this.title = this.data?.title;
    switch (this.data?.type) {
      case AttachmentTypeEnum.Video:
        return this.getInfoVimeo();
      case AttachmentTypeEnum.Audio:
        this.dataViewer = {
          name: this.data?.title,
          url: this.data?.url ? this.data?.url : this.data?.file,
        };
        break;
      case AttachmentTypeEnum.Html:
        this.dataViewer = {
          name: this.data?.title,
          html: this.data?.html,
        };
        break;
      default:
        this.dataViewer = {
          name: this.data?.title,
          url: this.data?.url ? this.data?.url : this.data?.file,
        };
        break;
    }
  }

  private getInfoVimeo() {
    const videoUrl = Vimeo.getVideoUrl(this.data);
    if (!!videoUrl) {
      this.dataViewer = {
        name: this.data?.title,
        url: videoUrl,
      };
      return;
    }

    const params = {
      id: this.data?.id,
      video: '/videos/' + Vimeo.getVideoId(this.data),
      conta: portalConst.vimeo_account,
    };

    this.video$ = this._attachmentService.checkVideo(params).pipe(
      take(1),
      map((res: any) => {
        if (!res.vimeo_hash) {
          this._alertService.alert({ message: 'geral.video-renderizando' });
          this._dialogRef.close();
        }
        return {
          name: this.data?.title,
          url: Vimeo.getVideoUrl({ ...this.data, vimeo_hash: res.vimeo_hash }),
        };
      }),
    );
  }

  public onClose() {
    this._dialogRef.close();
  }
}
